import { Box, BoxProps, ColorOptions, Spacer, Text, TextProps } from '@jfs/ui-new'
import { forwardRef, useState } from 'react'
import { FlatList, ScrollView } from 'react-native'
import { useStores } from '../../data/store'
import { convertHexToRGBA } from '../../utils'
import { PAYMENT_MODE_SUBTYPES } from '../../utils/constants'
import { staticStrings } from '../../utils/string'
import { TOneDropDownList } from '../TOneDropDownList'
import { TOneSearchBar } from '../TOneSearchBar'
import { LogoImage } from './LogoImage'

const getImage = (item: any, type: any) => {
  return <LogoImage imgUrl={item?.imageUrl ?? ''} type={type} />
}

export const toneListView = forwardRef(({ children, ...props }: any, ref: any) => {
  const { theme, getInstrumentsList } = useStores((root) => ({
    theme: root?.config?.merchantTheme,
    getInstrumentsList: root.getInstrumentsList,
  }))

  const [showAllBanks, setShowAllBanks] = useState(false)

  const { type, selectedItem, setSelectedItem, validateOfferState, applyOfferState, convFeeComp, amount } = props

  const typeTestId = type === PAYMENT_MODE_SUBTYPES.NB ? 'bank' : 'wallet'
  const instruments = getInstrumentsList(type)
  const popularKey = type === PAYMENT_MODE_SUBTYPES.NB ? 'Popular banks' : 'Popular Wallets'
  const otherKey = type === PAYMENT_MODE_SUBTYPES.NB ? 'Other banks' : 'Other Wallets'
  const otherBanks = instruments?.find((item: any) => item.title === otherKey) ?? []
  const subtitle =
    validateOfferState === 'rejected'
      ? type === PAYMENT_MODE_SUBTYPES.NB
        ? `${staticStrings.invalidOffer} bank`
        : `${staticStrings.invalidOffer} wallet`
      : applyOfferState === 'rejected'
        ? type === PAYMENT_MODE_SUBTYPES.NB
          ? `${staticStrings.invalidOffer} bank`
          : `${staticStrings.invalidOffer} wallet`
        : props.validateOfferState === 'fulfilled'
          ? staticStrings.offerApplied
          : ''

  const keyExtractor = (item: any): string => {
    return item?.id + getNumOfColumns()
  }

  const getNumOfColumns = () => {
    return 3
  }

  const title = type === PAYMENT_MODE_SUBTYPES.NB ? 'All Banks' : 'All Wallets'
  const topBanks = instruments?.find((item: any) => item.title === popularKey) ?? []

  const style = styles(theme)
  const renderGridItem = ({ item, index }: any) => {
    const itemClick = () => {
      setSelectedItem(`${item.id}`)
    }
    const getName = (name: string) => {
      if (name.length > 36) {
        return `${name.slice(0, 33)}...`
      }
      return name
    }
    const isSelected = selectedItem === `${item?.id}`
    return (
      <Box
        {...style.mobileGrid(isSelected)}
        height={108}
        width={'33.3%'}
        underlayColor={convertHexToRGBA(theme?.brandColor, 10) as ColorOptions}
        onPress={itemClick}
        testID={`bankId-${item?.id}`}
        justifyContent={'center'}>
        <Box testID={`${typeTestId}Id${index}`} {...style.listItemContainer} underlayColor="PRIMARY_LIGHT_GREY">
          <Box {...style.logoContainer}>{getImage(item, type)}</Box>
        </Box>
        <Box {...style.textContainer}>
          <Text
            {...style.itemText}
            color={isSelected ? (theme?.brandColor as ColorOptions) : (theme?.bodyTextColor as ColorOptions)}
            numberOfLines={2}>
            {getName(item?.text ?? '')}
          </Text>
        </Box>
      </Box>
    )
  }

  const getSelectedvalue = () => {
    const selectedBank = otherBanks.data?.find((item: any) => item.id === selectedItem)
    return selectedBank?.id ?? ''
  }

  if (showAllBanks) {
    return (
      <Box flex={1}>
        <TOneDropDownList
          data={otherBanks?.data ?? []}
          type={type}
          setSelectedItem={setSelectedItem}
          selectedValue={getSelectedvalue()}
          showSubTitle={
            props.validateOfferState === 'rejected'
              ? type === PAYMENT_MODE_SUBTYPES.NB
                ? `${staticStrings.invalidOffer} bank`
                : `${staticStrings.invalidOffer} wallet`
              : props?.applyOfferState === 'rejected'
                ? type === PAYMENT_MODE_SUBTYPES.NB
                  ? `${staticStrings.invalidOffer} bank`
                  : `${staticStrings.invalidOffer} wallet`
                : props.validateOfferState === 'fulfilled'
                  ? staticStrings.offerApplied
                  : ''
          }
          convFeeComp={convFeeComp}
          amount={amount}
        />
      </Box>
    )
  }

  console.log('showAllBanks', showAllBanks)
  return (
    <ScrollView
      {...props}
      ref={ref}
      scrollEventThrottle={10}
      onScroll={(e) => {
        props.onScroll(e)
      }}
      contentContainerStyle={{
        flex: 1,
      }}>
      <>
        <Text {...style.mobileHeaderTitle}>{topBanks?.title}</Text>
        {topBanks?.data?.length > 0 && <Spacer direction="vertical" size={24} />}
        <Box testID="flatlistWrapper">
          <FlatList
            testID={'walletListID'}
            data={topBanks?.data}
            renderItem={renderGridItem}
            numColumns={getNumOfColumns()}
            key={getNumOfColumns()}
            keyExtractor={keyExtractor}
          />
        </Box>
        {topBanks?.data?.length > 0 && <Spacer direction="vertical" size={24} />}
        {validateOfferState === 'rejected' && (
          <>
            <Text color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions} fontSize={12}>
              {subtitle}
            </Text>
            <Spacer direction="vertical" size={24} />
          </>
        )}
        {applyOfferState === 'rejected' && (
          <>
            <Text color={convertHexToRGBA(theme?.bodyTextColor, 50) as ColorOptions} fontSize={12}>
              {subtitle}
            </Text>
            <Spacer direction="vertical" size={24} />
          </>
        )}
        {convFeeComp && (
          <>
            {convFeeComp}
            <Spacer direction="vertical" size={24} />
          </>
        )}
        <Text {...style.mobileHeaderTitle}>{title}</Text>
        <Spacer direction="vertical" size={24} />
        <Box onPress={() => setShowAllBanks(true)}>
          <TOneSearchBar
            hide={false}
            onPress={() => setShowAllBanks(true)}
            placeholder={type === PAYMENT_MODE_SUBTYPES.NB ? 'Search banks' : 'Search Wallets'}
            value={''}
            autoFocus={false}
            theme={theme}
          />
        </Box>
      </>
      <Spacer direction="vertical" size={16} />
      {children}
    </ScrollView>
  )
})

const styles = (theme: any) => ({
  mobileGrid: (isSelected: boolean) =>
  ({
    borderColor: isSelected
      ? (theme?.brandColor as ColorOptions)
      : (convertHexToRGBA(theme?.brandColor, 10) as ColorOptions),
    borderWidth: isSelected ? 2 : 0.5,
    bg: isSelected ? (convertHexToRGBA(theme?.brandColor, 10) as ColorOptions) : (theme?.bodyBgColor as ColorOptions),
  } as BoxProps),
  listItemContainer: {
    padding: 16,
    alignItems: 'center',
    flex: 1,
    justifyContent: 'center',
  } as BoxProps,
  logoContainer: {
    height: 32,
    width: 32,
    justifyContent: 'center',
    alignItems: 'center',
    overflow: 'hidden',
  } as BoxProps,
  textContainer: {
    marginHorizontal: 8,
    marginBottom: 16,
  },
  itemText: {
    color: 'BLACK_75',
    fontSize: 12,
    fontWeight: '700',
    textAlign: 'center',
    fontFamily: 'jioType-medium',
  } as TextProps,
  mobileHeaderTitle: {
    color: theme?.bodyTextColor as ColorOptions,
    fontSize: 14,
    fontFamily: 'jioType-medium',
  } as TextProps,
})
